import React from "react";
import Button from "@mui/material/Button";
import { Pencil, RotateCw, Copy, Trash2, MapPin } from "lucide-react";

interface TaskActionsProps {
    canEdit: boolean;
    onEdit?: () => void;
    onSync: () => void;
    onClone: () => void;
    onDelete: () => void;
    onShowMap: () => void;
}

export const TaskActions: React.FC<TaskActionsProps> = ({
    canEdit,
    onEdit,
    onSync,
    onClone,
    onDelete,
    onShowMap,
}) => {
    if (!canEdit) return null;

    return (
        <div className="mb-3 pb-4 border-b border-slate-200 flex items-center justify-between flex-wrap gap-3">
            <div className="flex items-center gap-2 flex-wrap">
                {onEdit && (
                    <Button
                        onClick={onEdit}
                        variant="outlined"
                        size="small"
                        startIcon={<Pencil size={12} />}
                        sx={{ textTransform: "none" }}
                    >
                        Edit
                    </Button>
                )}
                <Button
                    onClick={onSync}
                    variant="outlined"
                    size="small"
                    startIcon={<RotateCw size={12} />}
                    sx={{ textTransform: "none" }}
                >
                    Sync
                </Button>
                <Button
                    onClick={onClone}
                    variant="outlined"
                    size="small"
                    startIcon={<Copy size={12} />}
                    sx={{ textTransform: "none" }}
                >
                    Clone
                </Button>
                <Button
                    onClick={onDelete}
                    variant="outlined"
                    color="error"
                    size="small"
                    startIcon={<Trash2 size={12} />}
                    sx={{ textTransform: "none" }}
                >
                    Delete
                </Button>
            </div>
            <Button
                onClick={() => {
                    console.log("VIEW MAP CLICKED");
                    onShowMap();
                }}
                variant="contained"
                color="secondary"
                size="small"
                startIcon={<MapPin size={16} />}
                sx={{ textTransform: "none", fontWeight: 600 }}
            >
                View Map
            </Button>
        </div>
    );
};
